import React, { Component } from 'react';
import { Button, Radio } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

class AddressPanel extends Component {
    constructor(props) {
        super();
        this.state = {
            selectedAddress: props.userData.addresses.filter(
                address => address.is_default == 1
            )[0]
        };
    }
    componentDidUpdate(prevProps) {
        if (
            prevProps.userData.addresses.length !=
            this.props.userData.addresses.length
        ) {
            if (this.props.userData) {
                this.setState({
                    selectedAddress: this.props.userData.addresses.filter(
                        address => address.is_default == 1
                    )[0]
                });
            }
        }
    }
    handleRadioChange = selectedAddress => () => {
        this.setState({ selectedAddress });

        this.props.setBookingAddress(selectedAddress);
    };
    render() {
        const { userData } = this.props;
        if (!this.state.selectedAddress) {
            return (
                <div className="container">
                    <FormattedMessage
                        id="addDefaultAddress"
                        defaultMessage="Add atleast one default address to book service."
                    />
                    <br />
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.props.addNewAddress()}
                    >
                        <FormattedMessage
                            id="address.addnew"
                            defaultMessage="Add New"
                        />
                    </Button>
                </div>
            );
        }
        return (
            <div className="col-md-12 main-panel">
                <div className="mb-4">
                    <h4 className="mb-2">
                        <FormattedMessage
                            id="address.choosetitle"
                            defaultMessage="Choose Address"
                        />
                    </h4>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => this.props.addNewAddress()}
                    >
                        <FormattedMessage
                            id="address.addnew"
                            defaultMessage="Add New"
                        />
                    </Button>
                </div>
                <div className="row">
                    {userData.addresses &&
                        userData.addresses.map((address, index) => {
                            return (
                                <div
                                    className="col-md-6 col-sm-6 col-12 mb-4"
                                    key={index}
                                >
                                    <div
                                        className="address-check"
                                        sytle={{ display: 'flex' }}
                                        key={address.key}
                                    >
                                        <Radio
                                            checked={
                                                address.key ==
                                                this.state.selectedAddress.key
                                                    ? true
                                                    : false
                                            }
                                            onChange={this.handleRadioChange(
                                                address
                                            )}
                                            value={
                                                address.is_default == 1
                                                    ? `1`
                                                    : `0`
                                            }
                                        />
                                        <span>
                                            {address.name}, {address.phone},{' '}
                                            {address.address_line1},{' '}
                                            {address.city}, {address.state},{' '}
                                            {address.country}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    return { userData: auth.userData };
};
const composedComponent = compose(
    withTheme(),
    connect(
        mapStateToProps,
        null
    )
);
export default composedComponent(withUser(AddressPanel));



// WEBPACK FOOTER //
// ./src/components/Booking/AddressPanel.jsx